import { z } from "zod";
import { assignableCommunityRoleValues, communityRoleValues, } from "../constant_values";
export const CommunityRoleSchema = z.enum(communityRoleValues);
export const AssignableCommunityRoleSchema = z.enum(assignableCommunityRoleValues);
